import { type WritableDraft } from 'immer';

import { type EngineState } from '../../+state/engine';

import { type AICommandPayload } from './command-payload.model';

export abstract class CommandExecutor<C extends AICommandPayload<any>> {
  abstract executeMutably(draft: WritableDraft<EngineState>, payload: C): void;
}
